import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import HeroContainer from './components/HeroContainer';
import StatsContainer from './components/StatsContainer';
import InfoContainer from './components/InfoContainer';
import RegisterButton from './components/RegisterButton';
import QuotesContainer from './components/QuotesContainer';
import FaqContainer from './components/FaqContainer';
import Footer from './components/Footer';
import { localizations } from '../localization/localization';
import { connect } from 'react-redux';
import * as Store from '../admin/store/companiesStore';
import { ApplicationState } from '../store';
import { apiBaseUrl } from '../env';
import NewsContainer from './components/NewsContainer';
import VideoContainer from './components/VideoContainer';
import UserCommentsContainer from './components/UserCommentsContainer';
import NewFeaturesContainer from './components/NewFeaturesContainer';
import ScreenCaptureContainer from './components/ScreenCaptureContainer';

const styles = (theme: Theme) => createStyles({
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#022639',
    fontFamily: 'Montserrat',
    fontSize: 16,
    letterSpacing: '0.0356em',
    lineHeight: 1.625,
    color: '#F7F8F9',
    [theme.breakpoints.down('md')]: {
      fontSize: 15
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },
  innerContainer: {
    maxWidth: 1440,
    marginTop: '48px',
  },
  innerContainerMobile: {
    maxWidth: 1440,
    marginTop: '38px',
  },
  lowerContainer: {
    marginTop: '4.375em',
    backgroundColor: '#033349',
    paddingLeft: '4.6875em',
    paddingRight: '4.6875em',
    paddingTop: '3.875em',
    paddingBottom: '4.375em'
  },
  lowerContainerMobile: {
    marginTop: '4.375em',
    backgroundColor: '#033349',
    padding: '4.6875em',
    paddingTop: '4.375em',
    paddingBottom: '4.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '2.9em',
    }
  },
  lowerVideoContainer: {
    alignItems: 'flex-start',
    marginTop: '0.375em',
    backgroundColor: '#022639',
    paddingLeft: '4.6875em',
    paddingRight: '4.6875em',
    paddingTop: '3.875em',
    paddingBottom: '0.375em'
  },
  lowerVideoContainerMobile: {
    alignItems: 'center',
    marginTop: '0.375em',
    backgroundColor: '#022639',
    padding: '4.6875em',
    paddingTop: '0.375em',
    paddingBottom: '0.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '0.375em',
    }
  },
});



const infoItems = [{
  title: localizations.landingPageView.infoItems.title1,
  content: localizations.landingPageView.infoItems.content1
}, {
  title: localizations.landingPageView.infoItems.title2,
  content: localizations.landingPageView.infoItems.content2
}, {
  title: localizations.landingPageView.infoItems.title3,
  content: localizations.landingPageView.infoItems.content3
}, {
  title: localizations.landingPageView.infoItems.title4,
  content: localizations.landingPageView.infoItems.content4
}];

const quotes = [{
  text: localizations.landingPageView.quotes.text1,
  name: localizations.landingPageView.quotes.name1,
}, {
  text: localizations.landingPageView.quotes.text2,
  name: localizations.landingPageView.quotes.name2
}, {
  text: localizations.landingPageView.quotes.text3,
  name: localizations.landingPageView.quotes.name3
}, {
  text: localizations.landingPageView.quotes.text4,
  name: localizations.landingPageView.quotes.name4
}, {
  text: localizations.landingPageView.quotes.text5,
  name: localizations.landingPageView.quotes.name5
}];

const faqItems = [{
  title: localizations.landingPageView.faqItems.title1,
  content: localizations.landingPageView.faqItems.content1
}, {
  title: localizations.landingPageView.faqItems.title2,
  content: localizations.landingPageView.faqItems.content2
}, {
  title: localizations.landingPageView.faqItems.title3,
  content: localizations.landingPageView.faqItems.content3
}, {
  title: localizations.landingPageView.faqItems.title4,
  content: localizations.landingPageView.faqItems.content4
}, {
  title: localizations.landingPageView.faqItems.title5,
  content: localizations.landingPageView.faqItems.content5
}, {
  title: localizations.landingPageView.faqItems.title6,
  content: localizations.landingPageView.faqItems.content6
}];

const userCommentItems = [{
  content: localizations.landingPageView.userComments.text4
},{
  content: localizations.landingPageView.userComments.text1
}, {
  content: localizations.landingPageView.userComments.text2
}, {
  content: localizations.landingPageView.userComments.text3
}];

const newsItems = [{
  title: localizations.landingPageView.newsItems.title3,
  content: localizations.landingPageView.newsItems.content3,
  link: localizations.landingPageView.newsItems.link3,
  readMore: localizations.landingPageView.newsItems.readMore3
}, {
  title: localizations.landingPageView.newsItems.title2,
  content: localizations.landingPageView.newsItems.content2,
  link: localizations.landingPageView.newsItems.link2,
  readMore: localizations.landingPageView.newsItems.readMore2
}, {
  title: localizations.landingPageView.newsItems.title1,
  content: localizations.landingPageView.newsItems.content1,
  link: localizations.landingPageView.newsItems.link,
  readMore: localizations.landingPageView.newsItems.readMore
}];

type LandingPageViewProps = Store.CompaniesState & typeof Store.actionCreators & WithStyles;
interface LandingPageViewState {
  registeredCompanies?: number;
  unitsAndTrucksTotal?: number;
  isMobile?: boolean;
}


class LandingPageView extends React.Component<LandingPageViewProps, LandingPageViewState> {
  constructor(props: LandingPageViewProps) {
    super(props);

    this.state = {
      registeredCompanies: undefined,
      unitsAndTrucksTotal: undefined,
      isMobile: false
    }
  }

  public componentDidMount() {

    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    this.setState({
      isMobile: isMobileDevice
    })

    fetch(apiBaseUrl + 'api/companies/registered').then(async response => {
      const data = await response.json();
      this.setState({
        registeredCompanies: data.registeredCount
      })
    })
    fetch(apiBaseUrl + 'api/statistics/unitsandtruckscount').then(async response => {
      const data = await response.json();
      this.setState({
        unitsAndTrucksTotal: data.totalCount
      })
    })
  }

  public render() {
    const { classes } = this.props;
    const { registeredCompanies, unitsAndTrucksTotal, isMobile } = this.state;

    const isMobileDevice = isMobile;

    const statistics = [/* {
      count: 100,
      text: "aktiivista käyttäjää"
    }, */ {
        count: registeredCompanies,
        text: localizations.landingPageView.statistics.text1
      }, {
        count: unitsAndTrucksTotal,
        text: localizations.landingPageView.statistics.text2
      }/* , {
      count: 100,
      text: "UnitSpotterin kautta löydettyjä kohteita"
    } */];

    return (
      <Grid container direction="column" justify="center" alignItems="center" className={classes.mainContainer}>
        <Grid item container direction="column" justify="center" alignItems="center" className={isMobile === false ? classes.innerContainer : classes.innerContainerMobile}>
          <HeroContainer />
          <StatsContainer items={statistics} />
          <VideoContainer items={infoItems} isMobile={isMobile} />
          <InfoContainer items={infoItems} isMobile={isMobileDevice} />
          <Grid item>
            <RegisterButton />
          </Grid>
          <Grid item container direction="column" alignItems="center" className={isMobile === false ? classes.lowerContainer : classes.lowerContainerMobile}>
            {/* Will be added later */}
            {/* <QuotesContainer items={quotes} /> 
          <Grid item>
            <RegisterButton />
          </Grid> */}
            <UserCommentsContainer isMobileDevice={isMobileDevice} items={userCommentItems} />
            <NewFeaturesContainer isMobileDevice={isMobileDevice} />
            <FaqContainer isMobileDevice={isMobileDevice} items={faqItems} />
            <Grid item>
              <RegisterButton />
            </Grid>
            <NewsContainer isMobileDevice={isMobileDevice} newsItems={newsItems} />
            <Grid item>
              <RegisterButton />
            </Grid>
            <ScreenCaptureContainer isMobile={isMobileDevice} />
          </Grid>
        </Grid>
        <Footer />
      </Grid>
    );
  }
}


export default connect<any>((state: ApplicationState) => state.companies, Store.actionCreators)(withStyles(styles)(LandingPageView));



// WEBPACK FOOTER //
// ./src/landingPage/LandingPageView.tsx